<template>
  <div class="filial-menu-list">
    <div class="filial-menu-list">
      <v-container fluid>
        <breadcrumbs />
        <v-row>
          <v-col>
            <h1 class="mb-1">
              Меню филиала
            </h1>
          </v-col>
          <v-col class="text-right">
            <v-btn
              v-if="selectedSource === 'sushiset'"
              depressed
              large
              class="mr-3"
              @click="showExportDialog"
            >
              <v-icon left v-text="`mdi-export-variant`" />
              Экспорт
            </v-btn>
            <v-btn
              :disabled="disableEdit"
              depressed
              color="success"
              large
              @click="goToEditPage"
            >
              <v-icon left v-text="`mdi-pencil`" />
              Изменить
            </v-btn>
          </v-col>
        </v-row>
        <v-alert v-if="error" color="error" dark>
          Ошибка загрузки: {{ error }}
        </v-alert>
        <v-row v-else>
          <v-col>
            <filial-menu-table
              :items="menuItems"
              :loading="loading"
              :selected-source="selectedSource"
              @remove-item="showRemoveDialog"
            >
              <template v-slot:top-filter>
                <div class="menu-brands-filter">
                  <source-horizontal-filter
                    v-model="selectedSource"
                    :show-all-btn="false"
                    :filial-id="filialId"
                  />
                </div>
              </template>
            </filial-menu-table>
          </v-col>
        </v-row>
        <remove-from-filial-menu-dialog
          v-model="removeDialogShow"
          :menu-item="selectedMenuItem"
          :loading="sendRequest"
          @confirm="removeFromFilialMenu"
        />

        <export-dialog v-model="exportDialogShow" :filial-id="filialId" />
      </v-container>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader.vue'
  import MenuItemsDataService from '@/services/api/MenuItemsDataService'
  import FilialMenuTable from '@/components/filial-menu/FilialMenuTable.vue'
  import { mapGetters } from 'vuex'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import RemoveFromFilialMenuDialog from '@/components/filial-menu/RemoveFromFilialMenuDialog.vue'
  import ExportDialog from '@/components/filial-menu/ExportDialog.vue'
  import BrandsHorizontalFilter from '@/components/filters/BrandsHorizontalFilter.vue'
  import AggregatorsBrand from '@/models/enums/AggregatorsBrand'
  import SourceHorizontalFilter from '@/components/filters/SourceHorizontalFilter.vue'
  import { isEmpty, isNull } from 'lodash'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'

  export default {
    name: 'FilialMenuList',
    components: {
      SourceHorizontalFilter,
      BrandsHorizontalFilter,
      ExportDialog,
      RemoveFromFilialMenuDialog,
      FilialMenuTable,
      Loader,
    },
    mixins: [SnackbarMessage],
    data () {
      return {
        loading: false,
        error: false,
        menuItems: [],
        removeDialogShow: false,
        exportDialogShow: false,
        selectedMenuItem: {},
        sendRequest: false,
        selectedSource: 'sushiset',
      }
    },
    computed: {
      ...mapGetters({
        filialId: 'branches/getGlobalFilialId',
      }),
      filter () {
        const filterData = {}

        if (this.selectedSource && this.selectedSource !== 'sushiset') {
          filterData.source = this.selectedSource
        }

        return filterData
      },
      disableEdit () {
        return (
          !this.userCan(CRMPermission.EditFilialMenu) ||
          this.selectedSource !== 'sushiset'
        )
      },
    },
    watch: {
      filter (value) {
        if (value.source === 'sushiset') {
          delete value.source
        }
        this.$router.push({
          path: this.$route.path,
          query: value,
        })

        this.loadMenuItems()
      },
      '$route.query.source': {
        handler: function (source) {
          if (!source) {
            source = 'sushiset'
          }
          console.log({ source })
          this.selectedSource = parseInt(source) || source
        },
        deep: true,
        immediate: true,
      },
    },
    async created () {
      this.loadMenuItems()
    },
    methods: {
      goToEditPage () {
        this.$router.push({ name: 'filialMenuEdit', query: this.filter })
      },
      showRemoveDialog (menuItem) {
        this.selectedMenuItem = menuItem
        this.removeDialogShow = true
      },
      showExportDialog () {
        this.exportDialogShow = true
      },
      async loadMenuItems () {
        this.loading = true
        try {
          this.menuItems = await MenuItemsDataService.getFilialMenu(
            this.filialId,
            this.filter,
          )
        } catch (err) {
          this.error = this.getErrorMessageFromResponse(err)
        }
        this.loading = false
      },

      async removeFromFilialMenu (menuItemId) {
        this.sendRequest = true
        try {
          await MenuItemsDataService.removeFromFilial(menuItemId, this.filialId)
          this.deleteItemFromList(menuItemId)
          this.removeDialogShow = false
        } catch (err) {
          this.showErrorFromResponse(err)
        }
        this.sendRequest = false
      },
      deleteItemFromList (menuItemId) {
        this.menuItems = this.menuItems.filter((item) => item.id !== menuItemId)
      },
    },
  }
</script>

<style scoped lang="less"></style>
